
import { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import generatecertificateapi from '../api/generatecertificateapi';
import loginapi from '../api/login';
import { APISERVERURL } from '../APIServerURL';
import SingleCertificate from '../components/SingleCertificate';

function EditConvoCertificateDetails({accessToken,setAccessToken,setRefreshFailed}) {
  const navigate = useNavigate();
  const [convocationNumber,setConvocationNumber]=useState('1'); 
  const [certificateType, setCertificateType] = useState("");
  const [rollno, setRollno] = useState("");

  const [isLoading,setIsLoading]=useState(false);
  const [showResult,setShowResult]=useState(false);
  const [certificate,setCertificate]=useState(null);

  

  const handleSearch = async (e) => {
    setIsLoading(true);
    try{
      const response= await generatecertificateapi.post('/getCertificateDetails',{convocationNumber, certificateType, rollno},{headers:{'Authorization':`Bearer ${accessToken}`}});    
      //alert(JSON.stringify(response.data.data));
      setCertificate(response.data.data);
      setIsLoading(false);setShowResult(true);
    }
    catch(err)
    {
      if( err.response.status===403)
        {
          navigate(`/accessdenied`); 
        }
      try{
        const config = { withCredentials: true };
        const x=await loginapi.get('/getAccessToken',config);
        //alert(JSON.stringify(x['data']['accessToken']));
        
        const nat=x['data']['accessToken'];
        setAccessToken(nat);
        
        setRefreshFailed(false);  
        //console.log(`ne at ${nat}`);
        //console.log(`Second at:${accessToken}`);
        //alert('ok');
        try{       
          const response= await generatecertificateapi.post('/getCertificateDetails',{convocationNumber, certificateType, rollno},{headers:{'Authorization':`Bearer ${nat}`}});    
          //alert(JSON.stringify(response.data.data));
          setCertificate(response.data.data); setIsLoading(false);setShowResult(true);
         }
         catch(err)
         {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
            
            setRefreshFailed(true);  
          alert('unusual error newposts.js');
          //setIsAppLoaded(true);
          //alert(JSON.stringify(err));
          //navigate('/');
         }
      }
      catch(err)
      {
        alert(JSON.stringify(err));
        
        setRefreshFailed(true);  
        //setIsAppLoaded(true);
        //setError(JSON.stringify(err));
        //navigate('/');
      }
    }
    finally{
      setIsLoading(false);
      setShowResult(true);
    }
  };

    return (
      <main className="flex flex-col items-center">
        <div className="w-[98%] max-w-[1200px] flex flex-col items-center">
            <div className="flex flex-col items-center">
              <div className="text-center mb-4">
                <h1 className="text-2xl font-bold text-gray-800 ">EDIT CONVOCATION CERTIFICATE DETAILS</h1>
              </div>

            </div>

            <div className="w-full flex flex-col items-center bg-gray-100">
                <div className="flex flex-col  p-2 w-[98%] max-w-[600px]">
                  <div className="flex flex-col p-2">
                    <label htmlFor="convocationType">Select Convocation Type:</label>
                    <select
                      id="convocationType"
                      value={certificateType}
                      onChange={(e) => {setShowResult(false);setCertificateType(e.target.value)}}
                      className="p-2 bg-transparent border-b-2 border-red-500 focus:border-green-500 outline-none"
                    >
                      <option value="">Please Select</option>
                      <option value="PG">PG</option>
                      <option value="UG">UG</option>
                      <option value="PG_GOLD">PG GOLD</option>
                      <option value="UG_GOLD">UG GOLD</option>
                      <option value="PHD">PhD</option>
                    </select>
                  </div>

                  <div className="flex flex-col p-2 mt-4 mb-2">
                    <label htmlFor="txtRollNo">RollNo</label>
                    <input
                      id="txtRollNo"
                      type="text"
                      value={rollno}
                      onChange={(e) => {setShowResult(false);setRollno(e.target.value)}}
                      className="w-full p-2 bg-transparent border-b-2 border-red-500 focus:border-green-500 outline-none"
                    />
                  </div>
                  <div className="text-end">
                      <button className="px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
                      onClick={handleSearch}
                      >
                        SEARCH
                      </button>
                  </div>
                </div>
            </div>
            <div className="w-full flex flex-col items-center bg-gray-100">
              {isLoading&&<p>Please wait</p>}
              {!isLoading && showResult && !certificate &&<p>No result to display!</p>}
              {!isLoading && showResult && certificate && 
                 (<div className="flex flex-col items-center w-[98%] max-w-[600px] p-1 mb-4"><SingleCertificate
                  certificate={certificate}
                  accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                 /></div>)
              }
            </div>
        </div>
      </main>
    )
  }
  
  export default EditConvoCertificateDetails